<template lang="pug">
  #app.fw--
    router-view
</template>

<script>

import { mapState } from 'vuex'

import 'verte/dist/verte.css'

export default {
  data () {
    return {
    }
  },  
  computed: {
  },
  methods: {
  }
}

</script>

<style lang="stylus">

@import './assets/styles/index.styl'
</style>
